module.exports = __webpack_public_path__ + "static/media/06_3.ce274bb1.png";